import React, { useEffect, useState } from 'react';
import * as PropTypes from 'prop-types';
import useClientsEventBookingContext from './hooks/useClientsEventBookingContext';
import useClientsEventBookingFormMutation from './hooks/useClientsEventBookingFormMutation';
import Calendar from '../../../../../base/calendar_tool/Calendar';

function AppointmentAvailabilities({ proceedTo }) {
  const [dateOverride, setDateOverride] = useState(null);
  const { clientsEventBooking, setProceedTo } = useClientsEventBookingContext();
  const { id: clientsEventId, upcomingAppointment: { id: upcomingAppointmentId, availability, appointmentType } } = clientsEventBooking;

  const [selectedAvailability, setSelectedAvailability] = useState((availability && availability.id) || '-1');
  const [processData, setProcessData] = useState(false);
  const { mutate } = useClientsEventBookingFormMutation();

  useEffect(() => {
    setProceedTo(proceedTo);
  }, [proceedTo, setProceedTo]);

  const handleSelectHour = (ua) => (e) => {
    e.preventDefault();
    const elements = document.querySelectorAll('.hours-buttons-list button');
    elements.forEach((element) => {
      element.classList.remove('active-hour');
    });

    document.getElementById(ua.id).classList.add('active-hour');
    setSelectedAvailability(ua.id);
  };

  const handleContinue = () => {
    setProcessData(true);
    const input = {
      id: clientsEventId,
      appointmentsAttributes: [{
        id: upcomingAppointmentId,
        usersAvailabilityId: selectedAvailability,
      }],
    };
    mutate(input, { canProceed: true });
  };

  window.addEventListener('beforeunload', (e) => {
    e.returnValue = 'Form is not complete. Are you sure you want to leave?';
  });

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      const script = document.createElement('script');

      script.src = 'https://181302.t.hyros.com/v1/lst/universal-script?ph=9ce99df8788751883d56ec077d783be0e2385d3244728ba58b2543d3f3c3fb7b&tag=!clicked';

      script.async = true;

      document.body.appendChild(script);

      return () => {
        // clean up the script when the component in unmounted
        document.body.removeChild(script);
      };
    }
  }, []);

  return (
    <div className="appointment-calendar-wrapper">
      <div className="text-container">
        <h1>Select a date</h1>
        {/*<p>Appointment duration: 1:00 hour</p>*/}
      </div>
      <Calendar
        key="appointment-availabilities-calendar"
        queryParams={{ withAvailabilities: false }}
        viewTypeSelect={false}
        displaySideHours={false}
        dateOverride={dateOverride}
        setCalendarType={() => false}
        calendarType="Month"
        admin={false}
        handleSelectHour={handleSelectHour}
        selectedAvailability={selectedAvailability}
        handleContinue={handleContinue}
        setSelectedAvailability={setSelectedAvailability}
        processData={processData}
        appointmentType={appointmentType}
      >
        {() => {}}
      </Calendar>
    </div>
  );
}

AppointmentAvailabilities.propTypes = {
  proceedTo: PropTypes.string.isRequired,
};

export default AppointmentAvailabilities;
